import { createPortal } from "react-dom";
import clsx from "../../../../modules/helpers/clsx";
import useWindowSize from "../../../../modules/helpers/windowSize";
import useMountTransition from "../../../../modules/player/hooks/useMountTransition";
import { FocusContext, useFocusable } from "../../../../modules/spatialNavigation";
import IconComponent from "../../icon/IconComponent";
import IconButton from "../../iconButton/IconButtonComponent";
import * as styles from "./styles.module.scss";

interface IProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
}

const TextDialog = (props: IProps) => {
  const { ref, focusKey } = useFocusable({
    focusBoundaryDirections: ["left", "right", "up", "down"],
    isFocusBoundary: true,
  });
  const { shouldFadeIn, shouldMount } = useMountTransition(props.open);
  const [width, height] = useWindowSize();

  if (!shouldMount) {
    return null;
  }

  const dialogContent = (
    <FocusContext.Provider value={focusKey}>
      <div
        className={clsx({
          [styles.dialog]: true,
          [styles.fade]: !shouldFadeIn,
        })}
        style={{ width, height }}
      >
        <div className={styles.dialogContainer} ref={ref}>
          <div className={styles.header}>
            <h2 className={styles.title}>{props.title}</h2>
            <IconButton
              focusKey="closeDialogButton"
              onClick={props.onClose}
              onEnterPress={props.onClose}
              className={styles.closeButton}
            >
              <IconComponent type="outlined" name="&#xe5cd;" />
            </IconButton>
          </div>
          <div className={styles.content}>
            <p className={styles.description}>{props.description}</p>
          </div>
        </div>
      </div>
    </FocusContext.Provider>
  );

  return createPortal(dialogContent, document.body);
};

export default TextDialog;
